/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Supervisor_AgentsInputs */

const en_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supervisor agents`)
};

const ar_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء المشرف`)
};

const bn_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সুপারভাইজার এজেন্ট`)
};

const de_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supervisor-Agenten`)
};

const es_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes supervisores`)
};

const fr_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents superviseurs`)
};

const pt_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes supervisores`)
};

const zh_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主管代理`)
};

const tr_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetleyici aracılar`)
};

const ru_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Агенты-супервайзеры`)
};

const pl_svchip_supervisor_agents = /** @type {(inputs: Svchip_Supervisor_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenci nadzorujący`)
};

/**
* | output |
* | --- |
* | "Supervisor agents" |
*
* @param {Svchip_Supervisor_AgentsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_supervisor_agents = /** @type {((inputs?: Svchip_Supervisor_AgentsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Supervisor_AgentsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_supervisor_agents(inputs)
	if (locale === "bn") return bn_svchip_supervisor_agents(inputs)
	if (locale === "de") return de_svchip_supervisor_agents(inputs)
	if (locale === "es") return es_svchip_supervisor_agents(inputs)
	if (locale === "fr") return fr_svchip_supervisor_agents(inputs)
	if (locale === "pt") return pt_svchip_supervisor_agents(inputs)
	if (locale === "zh") return zh_svchip_supervisor_agents(inputs)
	if (locale === "tr") return tr_svchip_supervisor_agents(inputs)
	if (locale === "ru") return ru_svchip_supervisor_agents(inputs)
	if (locale === "pl") return pl_svchip_supervisor_agents(inputs)
	return en_svchip_supervisor_agents(inputs)
});